import {inject, Injectable} from '@angular/core';
import {SessionService} from '../../../../../../services/session.service';
import {Match} from '../../../../../../model/events/Match';
import {
  DOMAIN_VALUE_CD_APPROVE_STATUS_APPROVED,
  DOMAIN_VALUE_CD_APPROVE_STATUS_TC1_APPROVED
} from '../../../../../../../assets/domains/domains';
import {AuthenticationService} from '../../../../../../services/auth/authentication.service';
import {PhaseHelper} from '../../../../../shared/event/phase-helper';

@Injectable({
  providedIn: 'root'
})
export class TeamleagueService
{
  private sessionService = inject(SessionService);
  private authenticationService = inject(AuthenticationService);

  userTeamId: number;
  isGuest: boolean;
  isTcHome: boolean;
  isTcAway: boolean;
  isHomeNotAllowed: boolean;
  isGuestNotAllowed: boolean;
  isEditingNotAllowed: boolean;
  isGuestAllowed: boolean;

  public static isEditingDenied(approveStatusCd: string, sessionService: SessionService): boolean
  {
    if (!sessionService.teamId)
      return false;
    return approveStatusCd === DOMAIN_VALUE_CD_APPROVE_STATUS_TC1_APPROVED ||
      approveStatusCd === DOMAIN_VALUE_CD_APPROVE_STATUS_APPROVED;
  }

  constructor()
  {
    this.userTeamId = this.sessionService.teamId;
  }

  public initLeagueMatch(match: Match): void
  {
    if (!match.matchReport)
      return;

    console.log('initLeagueMatch, userTeamId: ' + this.userTeamId + ', match: ', match);
    this.isGuest = false;
    this.isTcHome = false;
    this.isTcAway = false;
    this.isEditingNotAllowed = false;
    this.isHomeNotAllowed = false;
    this.isGuestNotAllowed = false;
    this.isGuestAllowed = false;

    if (this.userTeamId && !this.authenticationService.admin)
    {
      this.isTcHome = match.participantHome?.team?.id === this.userTeamId;
      this.isTcAway = match.participantGuest?.team?.id === this.userTeamId;

      if (PhaseHelper.isLineupWithoutLineupWithApproval(match.phase))
      {
        // Beide dürfen ihr Team editieren
        if (this.isTcHome)
          this.isGuestNotAllowed = true;
        else if (this.isTcAway)
        {
          this.isHomeNotAllowed = true;
          this.isGuestAllowed = true;
        }
      }

      if (this.isTcAway)
      {
        this.isGuest = true;
        this.isEditingNotAllowed = true;
      }
      else if (this.userTeamId > 0 && TeamleagueService.isEditingDenied(match.approveStatusCd, this.sessionService))
      {
        this.isEditingNotAllowed = true;
      }
    }
    console.log('isGuest: ' + this.isGuest + ', isEditingNotAllowed: ' + this.isEditingNotAllowed);
  }
}
